import React, { useState, useEffect, useContext } from "react";

import db from "../../../services/query";

import RowPhoto from "../../common/TdImg";
import PrintTable from "../common/PrintTable";
import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";

import { HalfYearContext } from "../../../contexts/halfYearContext";

const Contractors = () => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];

  const [tableTitles, setTableTitles] = useState({
    mainTitle: "طرف های قرارداد",
  });

  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "photo",
      label: "عکس",
      content: ({ photo }) => <RowPhoto src={photo} />,
    },
    { path: "name", label: "نام (فارسی)" },
    { path: "name_en", label: "نام (انگلیسی)" },
    { path: "phone", label: "شماره تماس" },
    { path: "email", label: "ایمیل" },
    { path: "remark", label: "ملاحظه" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    requestData();

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      let query = `contractors?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        title={tableTitles.mainTitle}
        printHeadTexts={printHeadTexts}
      />
      <PrintBodyTitle title={[]} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default Contractors;
